import { render } from "./Deliveries.vue?vue&type=template&id=cd7b00b8"
import script from "./Deliveries.vue?vue&type=script&lang=js"
export * from "./Deliveries.vue?vue&type=script&lang=js"
script.render = render

export default script